import { useContext, useEffect } from 'react';
import { CreateProps, SimpleForm, SimpleFormProps, useEditContext } from 'react-admin';

import { AppContext } from '@app/contexts';

import { DeleteConfirmation } from '@app/components/common/Table/DefaultTable/types';

import { DefaultFormToolbar } from './DefaultFormToolbar';

interface ToolbarProps {
  resourceSingular: string;
  hideDelete?: boolean;
  onClose?(): void;
  customDiscardValidation?(): boolean;
  resolveDeleteConfirmation?(resourceId: number): Promise<DeleteConfirmation>;
}

export type DefaultFormProps = Omit<CreateProps, 'children'> & SimpleFormProps & ToolbarProps;

export const DefaultForm = ({
  children,
  resourceSingular,
  hideDelete,
  customDiscardValidation,
  onClose,
  validate,
  defaultValues,
  resolveDeleteConfirmation,
  ...props
}: DefaultFormProps) => {
  const { handleChangeLoading } = useContext(AppContext);
  const { saving } = useEditContext();

  useEffect(() => {
    handleChangeLoading(!!saving);
  }, [saving, handleChangeLoading]);

  return (
    <SimpleForm
      {...props}
      defaultValues={defaultValues}
      validate={validate}
      toolbar={
        <DefaultFormToolbar
          resolveDeleteConfirmation={resolveDeleteConfirmation}
          onClose={onClose}
          customDiscardValidation={customDiscardValidation}
          resourceSingular={resourceSingular}
          hideDelete={hideDelete}
        />
      }>
      {/* This element doesn't actually have any interactive role, but we need to prevent the default behaviour
      from react-admin whenever 'Enter' key is pressed. */}
      {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions */}
      <div
        onKeyDown={(e) => {
          e.key === 'Enter' && e.preventDefault();
        }}>
        {children}
      </div>
    </SimpleForm>
  );
};
